import { AppContent } from 'content/AppContent';

import * as routes from '../../routes/manifest';
import { MetaContentValues } from '../MetaContentValues';

const articles: AppContent['articles'] = {
  metaContent: MetaContentValues.Articles,
  pageTitle: 'News and updates',
  secondaryTitle:
    "Here's where you can find the latest news and updates from BM Solutions.",
  backButtonLabel: 'Back',
  backButtonHref: routes.Articles,
  navigationTiles: [
    {
      linkText: `Improving the quality of rental homes benefits landlords and tenants`,
      boxText: `One in five households (19%) live in the private rented sector (PRS), a figure that has stayed...`,
      url: routes.ArticleImprovingQualityBenefitsLandlordsAndTenants,
      linkTestId: 'articles-navigation-rental-homes',
    },
    {
      linkText: `Let's get retrofit for the future`,
      boxText: `Our Landlord Retrofit Tool helps you give clients invaluable insight and support.`,
      url: routes.ArticleLetsGetRetrofitForTheFuture,
      linkTestId: 'articles-navigation-retrofit',
    },
    {
      linkText: `Buy-to-let changed. BM Solutions changed with it`,
      boxText: `Forget the new normal. The market is constantly evolving and so are we.`,
      url: routes.BuyToLetChangedBMSolutionsChangedWithIt,
      linkTestId: 'articles-navigation-buy-to-let',
    },
  ],
};

export default articles;
